import React from "react";
import "./ContactUs.css";
import { FaInstagram, FaEnvelope, FaLinkedin } from "react-icons/fa";

const teamMembers = [
  "Jeremiah Kim",
  "Shankar Gopaluni",
  "Anish Subramanian",
  "Rampranav Maremanda",
  "Sahith Chappidi",
  "Shourvik Santi",
  "Ishaan Joshy"
];

const ContactUs = () => {
  return (
    <div className="contact-container">
      {/* Background shapes */}
      <div className="background-shapes">
        <div className="circle circle1" />
        <div className="circle circle2" />
        <div className="circle circle3" />
      </div>

      {/* Hero Section */}
      <section className="contact-hero">
        <h1 className="contact-title">Contact Echelon</h1>
        <p className="contact-subtitle">
          Have questions, want to collaborate, or get involved? Reach out to us.
        </p>

        {/* Social Links */}
        <div className="contact-social">
          <a
            href="mailto:secureechelon@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon"
          >
            <FaEnvelope />
          </a>
          <a
            href="https://www.instagram.com/echeloncharlotte?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon"
          >
            <FaInstagram />
          </a>
          <a
            href="https://www.linkedin.com/in/echelon-charlotte"
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon"
          >
            <FaLinkedin />
          </a>
        </div>
      </section>

      {/* Team Members Section */}
      <section className="team-section">
        <h2 className="team-title">Meet Our Team</h2>
        <div className="team-grid">
          {teamMembers.map((member, idx) => (
            <div className="team-card" key={idx}>
              <div className="team-avatar">
                {member.split(" ").map((n) => n[0]).join("")}
              </div>
              <div className="team-name">{member}</div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default ContactUs;
